module.exports = __webpack_public_path__ + "img/shutterstock_462658072.223679bf.svg";